import TopTabNavigationRecruitment from "../navigation/TopTabNavigationRecruitment";
const Recruitment = ({ navigation }) => {
  return (
    <TopTabNavigationRecruitment drawer='Recruitment' />
  );
};

export default Recruitment;